var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",class:this.class},[_c('div',{staticClass:"lds-dual-ring"})])
}
var staticRenderFns = []

export { render, staticRenderFns }